"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UICaret = _interopRequireDefault(require("../icon/icons/UICaret"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _IconConstants = require("../icon/IconConstants");

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

var indicatorCanvasStyle = {
  display: 'block',
  width: '100%',
  visibility: 'hidden'
};
var indicatorCaretStyle = {
  position: 'absolute',
  width: '100%',
  left: 0,
  top: 0
};

var renderIcon = function renderIcon() {
  return (// To fix a bug in IE11 with extra space added to the SVG, this uses a
    // <canvas> element as a sibling to the SVG to work around it (detailed in
    // https://stackoverflow.com/a/30416241). Hack passed inline to keep this
    // more portable and keep the logic in the component vs. the stylesheet
    _react.default.createElement("div", {
      className: "private-accordion__indicator"
    }, _react.default.createElement("canvas", {
      width: _IconConstants.CARET_WIDTH,
      height: _IconConstants.CARET_HEIGHT,
      style: indicatorCanvasStyle
    }), _react.default.createElement(_UICaret.default, {
      style: indicatorCaretStyle,
      viewBoxHeight: _IconConstants.CARET_HEIGHT,
      viewBoxWidth: _IconConstants.CARET_WIDTH,
      width: 12
    }))
  );
};

var UIAccordionItem =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIAccordionItem, _PureComponent);

  function UIAccordionItem() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIAccordionItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIAccordionItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleTitleClick = function () {
      var _this$props = _this.props,
          onOpenChange = _this$props.onOpenChange,
          open = _this$props.open;
      onOpenChange((0, _SyntheticEvent.default)(!open));
    };

    return _this;
  }

  (0, _createClass2.default)(UIAccordionItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          animate = _this$props2.animate,
          children = _this$props2.children,
          Content = _this$props2.Content,
          contentClassName = _this$props2.contentClassName,
          disabled = _this$props2.disabled,
          __onOpenChange = _this$props2.onOpenChange,
          open = _this$props2.open,
          size = _this$props2.size,
          title = _this$props2.title,
          titleClassName = _this$props2.titleClassName,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["animate", "children", "Content", "contentClassName", "disabled", "onOpenChange", "open", "size", "title", "titleClassName"]);
      var computedTitleClassName = (0, _classnames.default)(titleClassName, 'private-accordion', "private-accordion--" + (0, _tshirtSize.toShorthandSize)(size), {
        'private-accordion--open': open
      });
      return _react.default.createElement("div", rest, _react.default.createElement(_UIClickable.default, {
        "aria-expanded": open,
        className: computedTitleClassName,
        disabled: disabled,
        onClick: this.handleTitleClick
      }, _react.default.createElement("span", {
        className: "private-accordion__text-wrapper"
      }, renderIcon(), title)), _react.default.createElement(_AccordionTransition.default, {
        Content: Content,
        duration: animate ? undefined : 0,
        className: (0, _classnames.default)('UIAccordionItem-content', 'private-accordion__content', contentClassName),
        open: open
      }, children));
    }
  }]);
  return UIAccordionItem;
}(_react.PureComponent);

UIAccordionItem.propTypes = {
  animate: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node,
  Content: _component.default,
  contentClassName: _propTypes.default.string,
  disabled: _propTypes.default.bool.isRequired,
  onOpenChange: _propTypes.default.func,
  open: _propTypes.default.bool,
  title: _propTypes.default.node.isRequired,
  titleClassName: _propTypes.default.string,
  size: _tshirtSize.allSizes
};
UIAccordionItem.defaultProps = {
  animate: true,
  disabled: false,
  open: false,
  size: 'extra-small'
};
UIAccordionItem.displayName = 'UIAccordionItem';

var _default = (0, _Controllable.default)(UIAccordionItem, ['open']);

exports.default = _default;
module.exports = exports.default;